import { STORE_FEATURE_FLAGS } from '../constants/actionTypes'

const initialState = {}

const featureFlagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case STORE_FEATURE_FLAGS:
      return Object.assign({}, state, action.value)
    default:
      return state
  }
}

export default featureFlagsReducer
export { initialState }
